import { XIcon } from "lucide-react";
import React from "react";
import { FaHome, FaBuilding, FaTimes } from "react-icons/fa";

interface UserTypeSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectHomeowner: () => void;
  onSelectOrganization: () => void;
}

export const UserTypeSelectionModal: React.FC<UserTypeSelectionModalProps> = ({
  isOpen,
  onClose,
  onSelectHomeowner,
  onSelectOrganization,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-white shadow-xl max-w-md w-full mx-4 transform transition-all">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h3 className="text-xl font-semibold text-gray-900">
            What type of user are you?
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <XIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-gray-600 mb-6 text-center">
            Please select the option that best describes you to get the most relevant experience.
          </p>
          
          <div className="space-y-4">
            {/* Homeowner Option */}
            <button
              onClick={onSelectHomeowner}
              className="w-full flex items-center p-4 border border-gray-200 hover:border-[#ED6E5C] hover:bg-gray-50 transition-all duration-200 group"
            >
              <div className="flex items-center justify-center w-12 h-12 bg-gray-100 group-hover:bg-[#ED6E5C] group-hover:text-white rounded-lg mr-4 transition-all duration-200">
                <FaHome className="w-6 h-6" />
              </div>
              <div className="text-left">
                <h4 className="font-semibold text-gray-900 mb-1">Homeowner</h4>
                <p className="text-sm text-gray-600">
                  I need help with personal home projects and repairs.
                </p>
              </div>
            </button>

            {/* Organization Option */}
            <button
              onClick={onSelectOrganization}
              className="w-full flex items-center p-4 border border-gray-200 hover:border-[#ED6E5C] hover:bg-gray-50 transition-all duration-200 group"
            >
              <div className="flex items-center justify-center w-12 h-12 bg-gray-100 group-hover:bg-[#ED6E5C] group-hover:text-white rounded-lg mr-4 transition-all duration-200">
                <FaBuilding className="w-6 h-6" />
              </div>
              <div className="text-left">
                <h4 className="font-semibold text-gray-900 mb-1">Organization</h4>
                <p className="text-sm text-gray-600">
                  I represent a business or organization looking to find talent.
                </p>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
